export default {"src":"/_next/static/media/multipleCardTrust.7ea6bc8a.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};